import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

export const showGuideInterFlow = async (options) => {
    const guideInterFlow = await ArkLoader.extensionService.getExtension(componentConfig.name);
    const eleId = 'dc-guide-interflow';
    let container = document.getElementById(eleId);
    if (!container) {
        container = document.createElement('div');
        container.id = eleId;
        document.body.appendChild(container);
    }
    guideInterFlow.show({
        container,
        isFusionDocGray: true,
        onClose: options.handleClose,
        isCopy: options.isCopy,
    });
};

export const hideGuideInterFlow = async () => {
    const guideInterFlow = await ArkLoader.extensionService.getExtension(componentConfig.name);
    guideInterFlow.hide();
};
